import isPlainObject from 'lodash/isPlainObject';
import runMingo from './runMingo';
/**
 * If there needs to be a mingo conversion, it runs it, otherwise return initial.
 * NOTE: this will not process hiddenValues, as they need to be processed only after user input.
 * @private
 * @param  {any} value
 * @param {Boolean} isHidden
 * @returns the result of mingo calculation, or the initial value if no calculation needed.
 */
const _processValue = (value, isHidden) => {
    if (isPlainObject(value) && value._calculate && !isHidden) {
        const { value: processedValue, error } = runMingo(value._calculate, {});
        return processedValue || error;
    }
    return value;
};
/**
 * Returns initial value for an ION field. Can process mingo if value or defaultValue has _calculate property
 * @param {import('../model').Field} fieldObj - An field object
 * @returns {( String | Number | Boolean | Array | Object )} A single value
 * @memberof module:ionHelpers
 */
const getInitialValue = (fieldObj) => {
    const { defaultValue, type, rules, value, uiDisplay, } = fieldObj;
    const shouldHide = uiDisplay?.isHidden;
    const items = rules?.items?.value;
    // do not mingo process REFERENCE fields
    const isReference = uiDisplay?.element === 'REFERENCE';
    // If there is an initial value check if it needs to be processed and use it.
    if (value !== undefined) {
        const processedVal = isReference ? value : _processValue(value, shouldHide);
        return processedVal;
    }
    // BOOL types have true and false values so catch those first
    if (type === 'BOOL' && typeof defaultValue === 'boolean') {
        return defaultValue;
    }
    // Next use the processed defaultValue unless that value is an array
    if (defaultValue !== undefined && !Array.isArray(defaultValue)) {
        const processedDefault = isReference ? value : _processValue(defaultValue, shouldHide);
        return processedDefault;
    }
    // If default is an array make sure there are some items to return
    if (Array.isArray(defaultValue) && defaultValue.length) {
        return defaultValue;
    }
    // Select inputs would have been set by now if there was a default/value
    // If it gets to here we need to be initialized it as undefined.
    if (type === 'STRING' && uiDisplay?.element === 'SELECT') {
        return undefined;
    }
    // sliders need a starting point if a default isn't supplied. use the required min rule to do so.
    if (uiDisplay?.element === 'SLIDER') {
        return rules?.min;
    }
    // Fall backs for strings arrays and and anything else that hasn't already been set.
    if (type === 'STRING') {
        return '';
    }
    if (type === 'ARRAY' && items) {
        return [];
    }
    if (type === 'ARRAY' && uiDisplay.element === 'CHECKBOX') {
        return [];
    }
    return '';
};
export default getInitialValue;
